<template>
  <div>
    <b-modal id="reject-modal" title="Reject publication" centered>
      <p class="mb-4">
        {{
          $t(
            "dashboard.superadmin.spaces.pending.reject-publication.description"
          )
        }}
      </p>

      <textarea
        cols="30"
        rows="5"
        class="form-control"
        placeholder="Message"
        v-model.trim="$v.reason.$model"
      ></textarea>

      <template #modal-footer>
        <div class="w-100">
          <div class="d-flex justify-content-end">
            <LoadingButton
              :text="$t('utils.send')"
              :classes="['btn-primary', 'w-50']"
              :loading="loading"
              :disabled="$v.$invalid"
              @click="reject()"
            />
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      loading: false,
      reason: ""
    };
  },
  validations: {
    reason: {
      required
    }
  },
  methods: {
    reject() {
      this.$emit("rejected", this.reason);
    }
  }
};
</script>

<style lang="scss" scoped>
textarea {
  border: 1.6px solid #000000;
  border-radius: 6px;

  &:focus {
    box-shadow: none;
    border: 1.6px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/info/components/RejectDialog.vue